module.exports = __webpack_public_path__ + "img/cross.edf13c86.svg";